var render, staticRenderFns
import script from "./dealer_fee_bill.vue?vue&type=script&lang=js"
export * from "./dealer_fee_bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58623702')) {
      api.createRecord('58623702', component.options)
    } else {
      api.reload('58623702', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_fee_bill/dealer_fee_bill.vue"
export default component.exports